import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { distinctUntilChanged } from 'rxjs';

import {
  NinetyToastOptions,
  NotificationActions,
  selectCreateButtonText,
  selectCreationMessage,
  selectIsCreating,
  selectLinkedItem,
  selectProcessingAttachments,
  selectUniversalCreateDefaultTab,
  selectUniversalCreateEnabled,
  selectUniversalCreateError,
  UniversalCreateActions,
} from '@ninety/mobile/platform/state';

import { selectUniversalCreateConfig } from './universal-create.selectors';

@Injectable()
export class UniversalCreateStore {
  private readonly store = inject(Store);

  /** Determines what features are rendered in the UniversalCreate as well as
   *  the user-friendly text associated with the given feature */
  public readonly segmentConfig$ = this.store.select(selectUniversalCreateConfig).pipe(distinctUntilChanged());

  public readonly defaultTab$ = this.store.select(selectUniversalCreateDefaultTab).pipe(distinctUntilChanged());

  public readonly enable$ = this.store.select(selectUniversalCreateEnabled).pipe(distinctUntilChanged());

  public readonly createButtonText$ = this.store.select(selectCreateButtonText).pipe(distinctUntilChanged());

  public readonly linkedItem$ = this.store.select(selectLinkedItem).pipe(distinctUntilChanged());

  public readonly isCreating$ = this.store.select(selectIsCreating).pipe(distinctUntilChanged());

  public readonly processingAttachments$ = this.store.select(selectProcessingAttachments).pipe(distinctUntilChanged());

  public readonly creationMessage$ = this.store.select(selectCreationMessage).pipe(distinctUntilChanged());

  public readonly error$ = this.store.select(selectUniversalCreateError).pipe(distinctUntilChanged());

  public resetCreateFormState() {
    this.store.dispatch(UniversalCreateActions.resetUniversalCreateState());
  }

  public toast(options: NinetyToastOptions) {
    if (options.message) this.store.dispatch(NotificationActions.showToast({ options }));
  }
}
